import BaseAPI from '@/apis/base/baseApi';

export default class _supplierInvoiceApi extends BaseAPI {
  apiName = 'SIV';
}

